import Network from '@/common/lib/Network';
import Store from '@/config/store';

const oMapping = {
    tnomc: 25,
    tcdev: 3,
    tsiret: 17,
    ttvacee: 17,
    tweb: 60,
    tcdiv: 3,
    tcsdiv: 3,
    tadr1l: 25,
    tadr2l: 25,
    tadr3l: 25,
    tcpostl: 10,
    tvillel: 30,
    tcpaysl: 3,
    tadr1f: 25,
    tadr2f: 25,
    tadr3f: 25,
    tcpostf: 10,
    tvillef: 30,
    tcpaysf: 3,
    tccom: 3,
    tlieuprod: 100,
    taut_four: 100,
    tcom: 2000,
}

const oMappingContact = {
    tfctc: 5,
    tnom: 25,
    tpnom: 25,
    ttel: 30,
    tmail: 40,
    // ttopc: 1
}

const oMappingTypology = {
    tmotcle: 40,
}

export default {

  sendHeader(oParams) {

    Object.keys(oParams).map((key, index) => {
      if(oMapping[key] !== undefined) {
        oParams[key] = oParams[key].padEnd(oMapping[key], ' ') ;
      }
    });

    let oObject = Object.keys(oParams).reduce((c, k) => (c[k.toUpperCase()] = oParams[k], c), {});

    delete oObject.TLPAYSL;
    delete oObject.TLPROVL;

    let post_data = {
      ds_i: oObject
    };

    let data = {
      piduser: Store.getters['application/get_application_user'].id,
      pcsoc: Store.getters['application/get_application_company'].PCSOC,
    }
  
    return Network.execute('POST', 'CWEBS0018A', data, post_data, {
      'content-type': 'application/json'
    });  
  },
  sendContact(aParams, nNumBon) {

    aParams.map((object, index) => {

      Object.keys(object).map((key, index) => {
        if(oMappingContact[key.toLowerCase()] !== undefined) {  
          object[key] = object[key].padEnd(oMappingContact[key.toLowerCase()], ' ') ;
        }
      });

      aParams[index] = object;
    })

    let post_data = {
      ds_i: {
        OUT: aParams   
      }
    };

    let data = {
      piduser: Store.getters['application/get_application_user'].id,
      pcsoc: Store.getters['application/get_application_company'].PCSOC,
      pnumbon: nNumBon
    }

    return Network.execute('POST', 'CWEBS0019A', data, post_data, {
      'content-type': 'application/json'
    });  
  },
  sendTypology(aParams, nNumBon) {
    
    aParams.map((object, index) => {

      Object.keys(object).map((key, index) => {
        if(oMappingTypology[key.toLowerCase()] !== undefined) {  
          object[key] = object[key].padEnd(oMappingTypology[key.toLowerCase()], ' ') ;
        }
      });

      aParams[index] = object;
    })

    let post_data = {
      ds_i: {
        OUT: aParams   
      }
    };

    let data = {
      piduser: Store.getters['application/get_application_user'].id,
      pcsoc: Store.getters['application/get_application_company'].PCSOC,
      pnumbon: nNumBon
    }

    return Network.execute('POST', 'CWEBS0020A', data, post_data, {
      'content-type': 'application/json'
    });
  },
  sendFile(aPieceJointe, num_bon) {

    const files = [...aPieceJointe];

    let form_data = new FormData();

    files.map((file, index) => {
      form_data.append('files['+index+']', file);
    });

    form_data.append('nNumBon', num_bon);
    form_data.append('sPcsoc', Store.getters['application/get_application_company'].PCSOC);
    
    return Network.execute('POST', 'upload_file', {}, form_data, {
      'Content-Type': 'multipart/form-data'
    });
  },
  sendFilePath(aPath, nNumBon) {

    let aPathTemp = Array();

    aPath.map((object, index) => {
      aPathTemp[index]  = {TCHEMIN: object}
    })

    let post_data = {
      ds_i: {
        OUT: aPathTemp
      }
    };

    let data = {
      piduser: Store.getters['application/get_application_user'].id,
      pcsoc: Store.getters['application/get_application_company'].PCSOC,
      pnumbon: nNumBon
    }

    return Network.execute('POST', 'CWEBS0021A', data, post_data, {
      'content-type': 'application/json' 
    });
  },
  getInfoEchantillon(oParams) {

    let oData = {
      piduser: Store.getters['application/get_application_user'].id,
      pcsoc: Store.getters['application/get_application_company'].PCSOC,
      fmod: oParams.fmod
    };

    if(oParams.ftail1 !== undefined && oParams.ftail1 != '') {
      oData.ftail1 = oParams.ftail1
    }
    if(oParams.ftail2 !== undefined && oParams.ftail2 != '') {
      oData.ftail2 = oParams.ftail2
    }
    if(oParams.fopt !== undefined && oParams.fopt != '') { 
      oData.fopt = oParams.fopt
    }
    if(oParams.fcol !== undefined && oParams.fcol != 0) { 
      oData.fcol = oParams.fcol
    }
    if(oParams.fmarq !== undefined && oParams.fmarq != 0) { 
      oData.fmarq = oParams.fmarq
    }

    return Network.execute('GET', 'CWEBS0025A', oData);
  },
  cardControl(aParams, nNumBon) {

    aParams.map((object, index) => {
      aParams[index]  = Object.keys(object).reduce((c, k) => (c[k.toUpperCase()] = object[k], c), {});
    })

    let post_data = {
      ds_i: {
        OUT: aParams   
      }
    };

    let data = {
      piduser: Store.getters['application/get_application_user'].id,
      pcsoc: Store.getters['application/get_application_company'].PCSOC,
      pnumbon: nNumBon
    }

    return Network.execute('POST', 'CWEBS0026A', data, post_data, {
      'content-type': 'application/json' 
    });
  }, 
  sendCard(aParams, nNumBon) {

    aParams.map((object, index) => {
      aParams[index]  = Object.keys(object).reduce((c, k) => (c[k.toUpperCase()] = object[k], c), {});
    })

    let post_data = {
      ds_i: {
        OUT: aParams   
      }
    };

    let data = {
      piduser: Store.getters['application/get_application_user'].id,
      pcsoc: Store.getters['application/get_application_company'].PCSOC,
      pnumbon: nNumBon
    }

    return Network.execute('POST', 'CWEBS0022A', data, post_data, {
      'content-type': 'application/json' 
    });
  },
  sendSample(aParams, nNumBon) {

    let aDataTemp = Array();

    aParams.map( object => {
      aDataTemp.push(Object.keys(object.oData).reduce((c, k) => (c[k.toUpperCase()] = object.oData[k], c), {}));
    })

    let post_data = {
      ds_i: {
        OUT: aDataTemp   
      }
    };

    let data = {
      piduser: Store.getters['application/get_application_user'].id,
      pcsoc: Store.getters['application/get_application_company'].PCSOC,
      pnumbon: nNumBon
    }
    

    return Network.execute('POST', 'CWEBS0022A', data, post_data, {
      'content-type': 'application/json' 
    });
  },
  sendSpecialRequest(oParams, nNumBon) {

    let oObject = Object.keys(oParams).reduce((c, k) => (c[k.toUpperCase()] = oParams[k], c), {});
    
    let post_data = {
      ds_i: {
        OUT: [oObject]  
      }
    };

    let data = {
      piduser: Store.getters['application/get_application_user'].id,
      pcsoc: Store.getters['application/get_application_company'].PCSOC,
      pnumbon: nNumBon
    }

    return Network.execute('POST', 'CWEBS0022A', data, JSON.stringify(post_data), {
      'content-type': 'application/json' 
    });
  },
  lineControl(aParams) {

    let aDataTemp = Array();

    aParams.map((object, index) => {
      aDataTemp.push(Object.keys(object).reduce((c, k) => (c[k.toUpperCase()] = object[k], c), {}));
    })

    let post_data = {
      ds_i: {
        OUT: aDataTemp   
      }
    };

    let data = {
      piduser: Store.getters['application/get_application_user'].id,
      pcsoc: Store.getters['application/get_application_company'].PCSOC
    }

    return Network.execute('POST', 'CWEBS0026A', data, post_data, {
      'content-type': 'application/json' 
    });
  },
  sendLines(aParams, nNumBon) {

    let aDataTemp = Array();

    aParams.map((object, index) => {
      aDataTemp.push(Object.keys(object).reduce((c, k) => (c[k.toUpperCase()] = object[k], c), {}));
    })

    let post_data = {
      ds_i: {
        OUT: aDataTemp   
      }
    };

    let data = {
      piduser: Store.getters['application/get_application_user'].id,
      pcsoc: Store.getters['application/get_application_company'].PCSOC,
      pnumbon: nNumBon
    }

    return Network.execute('POST', 'CWEBS0022A', data, post_data, {
      'content-type': 'application/json' 
    });
  },
  getGenCode(sCode) {

    let data = {
      piduser: Store.getters['application/get_application_user'].id,
      pcsoc: Store.getters['application/get_application_company'].PCSOC,
      pgenc: sCode
    };

    return Network.execute('GET', 'CWEBS0027A', data);
  },
  getMod(sCode) {

    let data = {
      piduser: Store.getters['application/get_application_user'].id,
      pcsoc: Store.getters['application/get_application_company'].PCSOC,
      pmod: sCode
    };

    return Network.execute('GET', 'CWEBS0076A', data);
  }
}